import React from 'react'
import { Link } from 'gatsby'

export default function PrepaidSidebar(): JSX.Element {
  return (
    <aside className="prepaid-sidebar">
      <div className="prepaid-sidebar-nav">
        <p className="prepaid-sidebar-nav__title">
          プリペイドカード会員メニュー
        </p>
        <ul className="prepaid-sidebar-nav__list">
          <li className="prepaid-sidebar-nav__list-item">
            <a
              className="prepaid-sidebar-nav__list-item-link"
              href="https://prepaid.su-pay.jp/regist/regist.html?goRegist=1"
              target="_blank"
              rel="noreferrer noopener"
            >
              初回利用登録
            </a>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <a
              className="prepaid-sidebar-nav__list-item-link"
              href="https://prepaid.su-pay.jp/regist/registPointSecond.html?goRegist=1"
              target="_blank"
              rel="noreferrer noopener"
            >
              残高照会・ポイント確認
            </a>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <a
              className="prepaid-sidebar-nav__list-item-link"
              href="https://prepaid.su-pay.jp/regist/registSecond.html?goRegist=1"
              target="_blank"
              rel="noreferrer noopener"
            >
              個人情報変更
            </a>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <a
              className="prepaid-sidebar-nav__list-item-link"
              href="https://prepaid.su-pay.jp/card-lost-replace/"
              target="_blank"
              rel="noreferrer noopener"
            >
              カード紛失・移行申請
            </a>
          </li>
        </ul>
      </div>
      <div className="prepaid-sidebar-nav">
        <p className="prepaid-sidebar-nav__title">プリペイドカードメニュー</p>
        <ul className="prepaid-sidebar-nav__list">
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/"
            >
              プリペイドカードとは
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/point/"
            >
              ポイントの貯め方・使い方
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/howto/"
            >
              使用方法
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/terms/"
            >
              利用規約・個人情報保護方針
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <a
              className="prepaid-sidebar-nav__list-item-link"
              href="https://prepaid.su-pay.jp/card-replace/reissue/index.html"
              target="_blank"
              rel="noreferrer noopener"
            >
              カードの再発行
            </a>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/contacts/"
            >
              カードのお問い合わせ
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/flow/"
            >
              入会・切替方法
            </Link>
          </li>
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/faq/#card"
            >
              よくあるご質問
            </Link>
          </li>
          {/* <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/myna-point/agreement/"
            >
              マイナポイント利用規約
            </Link>
          </li> */}
          {/* <li className="prepaid-sidebar-nav__list-item">
            <Link
              className="prepaid-sidebar-nav__list-item-link"
              to="/prepaid/myna-point/inquiry/"
            >
              マイナポイント申込お問い合わせ
            </Link>
          </li> */}
          <li className="prepaid-sidebar-nav__list-item">
            <Link
              to="/prepaid/regi-cart/"
              className="prepaid-sidebar-nav__list-item-link"
            >
              トライアルレジカート
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  )
}
